<div class="offering-related-technology">
  <h1 class="ui-heading-1-bold offering-related-technology-title">
    {{ section() }}
  </h1>

  <table rds-table [dataSource]="relatedTechnologyDataSource" density="spacious">
    <ng-container rdsColumnDef="targetName">
      <th rds-header-cell *rdsHeaderCellDef>Related technology name</th>
      <td rds-cell *rdsCellDef="let element">
        {{ element.targetId.content.displayName || "—" }}
      </td>
    </ng-container>

    <ng-container rdsColumnDef="description">
      <th rds-header-cell *rdsHeaderCellDef>Related technology description</th>
      <td rds-cell *rdsCellDef="let element">
        <span>{{ element.description }}</span>
      </td>
    </ng-container>

    <ng-container rdsColumnDef="targetUrl">
      <th rds-header-cell *rdsHeaderCellDef>Panorama link</th>
      <td rds-cell *rdsCellDef="let element">
        <a
          class="link"
          rds-link
          standalone
          [routerLink]="['/offerings', element?.targetId?.slug]"
          [attr.aria-label]="element?.targetId?.content?.displayName"
        >
          {{ BUTTONS.CLICK_HERE }}
        </a>
      </td>
    </ng-container>

    <tr rds-header-row *rdsHeaderRowDef="relatedTechnologyColumns"></tr>
    <tr rds-row *rdsRowDef="let row; columns: relatedTechnologyColumns"></tr>
  </table>
</div>
